import {
  AUTH_PATHS,
  EXTENSION_PATH_PREFIX,
  EXTENSION_SOURCE_PARAM,
  EXTENSION_SOURCE_VALUE,
} from './constants.js';

/**
 * Builds a sign-in URL with callbackUrl and, if the user is currently on an
 * extension path, a `source=extension` signal. The signal ensures AutoRedirect
 * refuses to fall through to a dashboard path even if callbackUrl is lost.
 *
 * TODO: remove this function once the extension has its own dedicated sign-in
 * page. The source fallback exists only because the extension currently shares
 * the dashboard's sign-in route — a corrupted callbackUrl would otherwise land
 * the user on the dashboard home inside the extension iframe.
 */
export function buildSignInRedirect(currentPath: string, encodedCallbackUrl: string): string {
  const isExtension = currentPath.startsWith(EXTENSION_PATH_PREFIX);
  const source = isExtension ? `&${EXTENSION_SOURCE_PARAM}=${EXTENSION_SOURCE_VALUE}` : '';
  return `${AUTH_PATHS.SIGN_IN}?callbackUrl=${encodedCallbackUrl}${source}`;
}
